<template>
  <v-app>
    <Header />
    <v-main>
      <v-container fluid class="pt-0">
        <router-view />
      </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Header from "@/components/app/Header.vue";
import Footer from "@/components/app/Footer.vue";

export default {
  components: { Header, Footer },
};
</script>

<style lang="scss" scoped></style>
